<template>
  <b-card title="Beneficiarios">
    <b-skeleton-table
        :rows="5"
        :columns="6"
        :table-props="{ bordered: true, striped: true }"
        v-if="loading"
    ></b-skeleton-table>
    <b-table
        ref="tblBeneficiaries"
        responsive
        :fields="tableColumns"
        :items="data"
        primary-key="id"
        show-empty
        empty-text="Nenhum registro encontrado"
        class="position-relative tblBeneficiaryResume"
        v-else
    >
      <template #cell(valor)="data">
        {{ data.item.valor }}
        <span class="ml-1">
          <b-badge variant='info'>
          <span style="cursor: pointer" @click="openBeneficiaryValues(data.item.id)">
            Abrir tabela de valores
          </span>
        </b-badge>
        </span>
      </template>
    </b-table>
    <TableValuesBeneficiary :id="idBeneficiaryOpenValues" v-if="idBeneficiaryOpenValues !== null" @closedModal="handleCloseModalTableValueBeneficiaries"/>
  </b-card>
</template>

<script>
import moment from 'moment';
import BeneficiaryService from "@/services/BeneficiaryService";
import TableValuesBeneficiary from "@/components/TableValuesBeneficiary";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  name: "Beneficiaries",
  components:{
    TableValuesBeneficiary
  },
  mounted() {
    this.loading = true;
    BeneficiaryService.get().then(resp => {
      this.data = resp.data.map(item => {
        return {
          id: item.id,
          beneficiario: item.nome_completo,
          tipo_beneficiario: item.tipo_usuario === 1 ? 'Titular' : 'Dependente',
          taxa_administrativa: parseFloat(item.taxa_administrativa)
              .toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' }),
          valor: parseFloat(item.valor)
              .toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' }),
          data_vigencia: moment(item.data_vigencia).format('DD/MM/YYYY'),
          carteirinha: item.num_carteirinha
        }
      })
      this.loading = false;
    }).catch(err => {
      this.loading = false;
      this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Oops!',
              icon: 'BellIcon',
              text: 'Ocorreu um erro ao buscar os beneficiarios.',
              variant: 'danger',
            },
          },
          {
            position: 'top-center'
          })
    })
  },
  data(){
    return {
      loading: false,
      tableColumns: [
        { key: 'id', sortable: false },
        { key: 'beneficiario', sortable: false },
        { key: 'tipo_beneficiario', sortable: false },
        { key: 'data_vigencia', sortable: false },
        { key: 'taxa_administrativa', sortable: false },
        { key: 'valor', sortable: false },
        { key: 'carteirinha', sortable: false },
      ],
      data: [],
      idBeneficiaryOpenValues: null,
    }
  },
  methods:{
    openBeneficiaryValues(id) {
      this.idBeneficiaryOpenValues = id;
    },
    handleCloseModalTableValueBeneficiaries() {
      this.idBeneficiaryOpenValues = null
    }
  }
}
</script>

<style scoped>

</style>